<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      Patient List Log
      <v-spacer></v-spacer>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search: Patient ID, Phone, Name, Family Eye Card"
          single-line
          hide-details
          outlined
          dense
      ></v-text-field>
    </v-card-title>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          :server-items-length="totalItems"
          :options.sync="options"
          class="elevation-1"
          @update:options="patientListLog"
          disable-pagination
          :hide-default-footer="true"
      >
        <template v-slot:item.patient_phone="{ item }">
          {{ item.patient_phone }}
          <v-chip
              outlined
              v-if="item.change_phone_number"
              small
              class="ml-1"
              :color="getColor(item.change_phone_number_status)"
          >
            {{ item.change_phone_number_status || 'Done' }}
          </v-chip>
        </template>
        <template v-slot:item.change_phone_number="{ item }">
          <span v-if="item.change_phone_number">{{ item.change_phone_number }}</span>
          <span v-else>—</span>
        </template>
      </v-data-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4">
            <v-pagination
                v-model="options.page"
                :length="totalPages"
                class="mt-4"
                @input="patientListLog"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      search: "",
      totalItems: 0,
      totalPages: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      loading: true,
      headers: [
        {text: "sl", value: "id"},
        {text: "Patient Id", value: "patient_id"},
        {text: "Patient Phone", value: "patient_phone"},
        {text: "New Phone", value: "change_phone_number"},
        {text: "Patient Name", value: "patient_name"},
        {text: "Patient DOB", value: "dob"},
        {text: "Referral Doctor", value: "referral_doctor_id"},
        {text: "Family Eye Card", value: "family_eye_card"},
        {text: "Created At", value: "created_date"},
        {text: "User", value: "user.full_name"},
      ],
      desserts: [],
      items: [
        {text: "Dashboard", disabled: false, href: "/"},
        {text: "Patient List Log", disabled: true, href: "/"},
      ],
    };
  },
  created() {
    if (!this.hasFullAccess()) {
      this.$router.push('/error/403');
      return;
    }
    this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.patientListLog();
      },
      deep: true,
    },
    search() {
      this.patientListLog();
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      this.patientListLog();
    },
    async patientListLog() {
      this.loading = true;
      this.desserts = [];
      await atshq
          .get("patients/patient-list-log", {
            params: {
              page: this.options.page,
              itemsPerPage: this.options.itemsPerPage,
              search: this.search,
              login_user_id: localStorage.getItem("userId"),
            }
          })
          .then((response) => {
            this.desserts = response.data.patient_list_logs.data;
            this.totalItems = response.data.patient_list_logs.total;
            this.totalPages = response.data.patient_list_logs.last_page;
            this.loading = false;
          })
          .catch((e) => {
            const msg = (e.response && e.response.data && (e.response.data.message || e.response.data.messages))
                || 'Something went wrong';
            this.$noty.error(msg);
            this.loading = false;
          });
    },
    getColor(status) {
      switch (status) {
        case 'Cancel':
          return 'red';
        case 'Done':
          return 'success';
        default:
          return 'success';
      }
    },
  },
};
</script>
